import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';

const styles = theme => ({
  lightTooltip: {
    background: colors.theWhiteAlbum,
    color: colors.squid,
    boxShadow: theme.shadows[1],
    fontSize: fontSize.small,
    marginBottom: '4px',
    opacity: 1.0,
    padding: '16px',
  },
  icon: {
    width: '12px',
    height: '12px',
    marginLeft: '6px',
    verticalAlign: 'baseline',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'center',
  },
});

class CustomizedTooltips extends PureComponent {
  render() {
    const { classes, showInfoIcon } = this.props;

    return (
      <Tooltip
        disableFocusListener
        disableTouchListener
        placement="top"
        title={<Fragment>{this.props.title}</Fragment>}
        classes={{ tooltip: classes.lightTooltip }}
      >
        <div className={classes.titleContainer}>
          {this.props.children}
          {showInfoIcon && (
            <img
              className={classes.icon}
              src={'/images/icons/confirm_info.svg'}
              width={12}
              height={12}
              alt=""
            />
          )}
        </div>
      </Tooltip>
    );
  }
}

CustomizedTooltips.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  showInfoIcon: PropTypes.bool,
  placement: PropTypes.string,
};

CustomizedTooltips.defaultProps = {
  showInfoIcon: true,
};

export default withStyles(styles)(CustomizedTooltips);
